import type { TimeZone } from "@eroad/types";

const AU_TIMEZONES: TimeZone[] = [
  {
    cities:
      "Adelaide_Gawler_Kadina_Mount Gambier_Murray Bridge_Port Augusta_Port Lincoln_Port Pirie_Victor Harbor_Whyalla".split(
        "_",
      ),
    timeZone: "Australia/Adelaide",
  },
  {
    cities: "Alice_Darwin_Jabiru_Katherine_Maningrida_Nhulunbuy_Palmerston_Tennant_Wadeye_Yulara".split("_"),
    timeZone: "Australia/Darwin",
  },
  { cities: ["Eucla"], timeZone: "Australia/Eucla" },
  {
    cities: "Brisbane_Canberra_Geelong_Gold Coast_Hobart_Melbourne_Newcastle_Sunshine Coast_Sydney_Wollongong".split(
      "_",
    ),
    timeZone: "Australia/Sydney",
  },
  {
    cities: "Albany_Broome_Bunbury_Busselton_Geraldton_Kalgoorlie_Karratha_Mandurah_Perth_Port Hedland".split("_"),
    timeZone: "Australia/Perth",
  },
  { cities: ["Lord Howe"], timeZone: "Australia/Lord_Howe" },
];

export { AU_TIMEZONES };
